export const ACTIVE_PRODUCT_STATES = ['paid', 'trial']
